(() => {
  'use strict';
  const subscriberKey = 'bv-subscriber-v1';
  const cookieFlag = name => document.cookie.split('; ').some(v => v === `${name}=1`);
  const rememberSubscriber = () => {
    try { localStorage.setItem(subscriberKey, '1'); } catch {}
    const host = location.hostname;
    const domain = host === 'biovita.co.za' || host.endsWith('.biovita.co.za') ? '; Domain=biovita.co.za' : '';
    document.cookie = `bv_subscriber=1; Max-Age=31536000; Path=/; SameSite=Lax${domain}${location.protocol === 'https:' ? '; Secure' : ''}`;
  };
  const knownSubscriber = root => {
    if (root.dataset.subscriber === 'true' || document.querySelector('[data-bv-signup-success]') || cookieFlag('bv_subscriber') || cookieFlag('bv_welcome_done')) return true;
    try {
      if (localStorage.getItem(subscriberKey) === '1') return true;
      const previous = JSON.parse(localStorage.getItem('bv-welcome-v3') || sessionStorage.getItem('bv-welcome-v3') || '{}');
      return previous.completed === true || previous.subscribed === true;
    } catch { return false; }
  };
  if (document.querySelector('[data-bv-signup-success]')) rememberSubscriber();
  window.addEventListener('klaviyoForms', event => {
    if (event.detail?.type === 'submit') {
      rememberSubscriber();
      window.dispatchEvent(new Event('bv:subscriber'));
    }
  });
  document.querySelectorAll('[data-bv-welcome]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog');
    if (!dialog?.showModal) return;
    const title = root.querySelector('#bv-welcome-title');
    const teaser = root.querySelector('[data-welcome-open]');
    const form = root.querySelector('form');
    const preview = root.dataset.preview === 'true';
    // Keep contact details out of browser storage; retain only signup suppression.
    if (!preview && knownSubscriber(root)) { rememberSubscriber(); root.hidden = true; return; }
    let memory = {};
    const read = () => memory;
    const save = value => { memory = value; };
    const visitKey = 'bv-welcome-visit-v1';
    const visitCookie = 'bv_welcome_visit';
    const visitWindow = 30 * 60 * 1000;
    let visitMemory;
    const readVisit = () => {
      if (visitMemory) return visitMemory;
      let stored;
      try { stored = sessionStorage.getItem(visitKey); } catch {}
      if (!stored) {
        const value = document.cookie.split('; ').find(item => item.startsWith(`${visitCookie}=`))?.split('=')[1];
        try { stored = value ? decodeURIComponent(value) : ''; } catch {}
      }
      try {
        const value = JSON.parse(stored || '{}');
        return value && Number.isFinite(value.lastSeen) ? value : {};
      } catch { return {}; }
    };
    const saveVisit = value => {
      visitMemory = value;
      try { sessionStorage.setItem(visitKey, JSON.stringify(value)); } catch {}
      // Only display timing is retained. No email, phone or signup status.
      const host = location.hostname;
      const domain = host === 'biovita.co.za' || host.endsWith('.biovita.co.za') ? '; Domain=biovita.co.za' : '';
      document.cookie = `${visitCookie}=${encodeURIComponent(JSON.stringify(value))}; Max-Age=1800; Path=/; SameSite=Lax${domain}${location.protocol === 'https:' ? '; Secure' : ''}`;
    };
    // This is a guaranteed welcome-offer reveal, as disclosed above the board.
    const prizeIndex = 2;
    const prizes = ['10% OFF', '20% OFF', '30% OFF', 'BUY 2, GET 1 FREE'];
    const prizeTags = ['first-sub-10', 'first-sub-20', 'first-sub-30', 'first-sub-buy2get1'];
    let opener, timer, playing = false, submitting = false, autoPending = false, current = 'game', answer = 'exploring';
    const status = root.querySelector('[data-welcome-status]');
    const steps = {game:['Tap to Drop',1], email:['Your welcome offer.',2], question:['One last thing\u2026',3], success:['Choose your supply.',4]};
    const step = name => {
      current = name;
      dialog.dataset.step = name;
      root.querySelectorAll('[data-welcome-step]').forEach(el => { el.hidden = el.dataset.welcomeStep !== name; });
      title.textContent = steps[name][0];
      root.querySelector('[data-welcome-progress]').textContent = `${steps[name][1]} OF 4`;
      dialog.scrollTop = 0;
      if (dialog.open) title.focus({preventScroll:true});
    };
    const open = () => {
      if ((!preview && knownSubscriber(root)) || dialog.open || document.querySelector('dialog[open]')) return;
      opener = document.activeElement;
      dialog.showModal();
      autoPending = false;
      clearTimeout(timer);
      if (!preview) saveVisit({...readVisit(), lastSeen:Date.now(), shown:true});
      document.documentElement.classList.add('bv-welcome-open');
      teaser.hidden = true;
    };
    dialog.addEventListener('close', () => {
      clearTimeout(timer);
      autoPending = false;
      document.documentElement.classList.remove('bv-welcome-open');
      if (!preview) save({...read(), dismissed:Date.now()});
      teaser.hidden = !preview && knownSubscriber(root);
      teaser.textContent = current === 'success' ? 'Your welcome offer' : 'Play for a perk';
      opener?.focus?.({preventScroll:true});
    });
    root.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    teaser.addEventListener('click', () => {
      if (read().attempted && current === 'game') step('email');
      open();
    });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    const renderPrize = () => {
      root.querySelector('.bv-welcome-reward').textContent = prizes[prizeIndex];
      root.querySelector('[data-welcome-prize-terms]').textContent = prizeIndex === 3
        ? 'Get three pouches for the price of two on your first subscription delivery. First delivery: R900 for three pouches. Then R1,215 for three pouches every 60 days. Choose the 60-day option at launch.'
        : `${[10,20,30][prizeIndex]}% off your first subscription delivery. Applies to the 20-day or 60-day subscription. `;
    };
    renderPrize();
    root.querySelector('[data-welcome-play]').addEventListener('click', () => {
      if (playing) return;
      playing = true;
      if (!preview) save({...read(), prize:prizeIndex});
      root.querySelector('.bv-lemon-game').style.setProperty('--drop-animation', `bv-prize-drop-${prizeIndex}`);
      root.querySelector('.bv-lemon-game').style.setProperty('--landing-x', '45px');
      root.querySelector('.bv-lemon-game').classList.add('is-playing');
      root.querySelector('[data-welcome-play]').disabled = true;
      const board = root.querySelector('.bv-lemon-game');
      const instruction = root.querySelector('[data-game-instruction]');
      instruction.textContent = 'Watch your little perk drop\u2026';
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveal = () => {
        board.classList.add('has-landed');
        instruction.textContent = `${prizes[prizeIndex]} \u2014 your welcome treat.`;
        root.querySelector(`[data-prize-slot="${prizeIndex}"]`).classList.add('is-winner');
        renderPrize();
        setTimeout(() => { playing = false; step('email'); }, reducedMotion ? 0 : 900);
      };
      if (reducedMotion) reveal();
      else root.querySelector('.bv-game-ball').addEventListener('animationend', reveal, {once:true});
    });
    const continueToQuestion = () => {
      if (form.reportValidity()) { status.textContent = ''; step('question'); }
    };
    root.querySelector('[data-welcome-email]').addEventListener('click', continueToQuestion);
    root.querySelector('[data-welcome-back]').addEventListener('click', () => { status.textContent = ''; step('email'); });
    root.querySelectorAll('[data-welcome-answer]').forEach(button => button.addEventListener('click', () => {
      if (submitting) return;
      answer = button.dataset.welcomeAnswer;
      form.requestSubmit();
    }));
    const completed = () => {
      if (!preview) { save({...read(), completed:true, attempted:false, dismissed:Date.now()}); rememberSubscriber(); }
      clearTimeout(timer);
      teaser.hidden = true;
      status.textContent = '';
      step('success');
      form.reset();
    };
    form.addEventListener('submit', async event => {
      // This form never posts to Shopify /contact, /cart or a fallback URL.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (current === 'email') { continueToQuestion(); return; }
      if (submitting || current !== 'question') return;
      if (!form.checkValidity()) { step('email'); form.reportValidity(); return; }
      if (preview) { completed(); return; }
      submitting = true;
      save({...read(), attempted:true, dismissed:Date.now()});
      root.querySelectorAll('[data-welcome-answer], [data-welcome-back]').forEach(button => { button.disabled = true; });
      status.textContent = 'Saving your details...';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const attributes = {
          email: form.querySelector('[type=email]').value.trim(),
          subscriptions: {email:{marketing:{consent:'SUBSCRIBED'}}},
          properties: {biovita_signup_source:'welcome-game', biovita_interest:answer, biovita_offer:'first-sub-30'}
        };
        if (!root.dataset.klaviyoSite || !root.dataset.klaviyoList) throw new Error('Signup configuration missing');
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(root.dataset.klaviyoSite)}`, {
          method:'POST', signal:controller.signal,
          headers:{'Content-Type':'application/vnd.api+json', Accept:'application/vnd.api+json', revision:'2026-10-15'},
          body:JSON.stringify({data:{type:'subscription', attributes:{custom_source:'Bio Vita welcome game', profile:{data:{type:'profile', attributes}}}, relationships:{list:{data:{type:'list', id:root.dataset.klaviyoList}}}}})
        });
        if (response.status !== 202) {
          if (response.status === 429) throw new Error('Please wait a moment, then try again.');
          throw new Error('We could not save your details. Go back to check your email address, then try again.');
        }
        // 202 means accepted for processing, not confirmed double opt-in.
        completed();
      } catch (error) {
        status.textContent = error.name === 'AbortError' || error instanceof TypeError
          ? 'We could not confirm your signup. Please check your connection and try again.'
          : error.message;
      } finally {
        clearTimeout(timeout);
        submitting = false;
        root.querySelectorAll('[data-welcome-answer], [data-welcome-back]').forEach(button => { button.disabled = false; });
      }
    }, true);
    root.querySelectorAll('[data-welcome-plan]').forEach(link => link.addEventListener('click', () => {
      if (!preview) save({...read(), completed:true, dismissed:Date.now()});
    }));
    const hideForSubscriber = () => {
      if (preview || !knownSubscriber(root)) return;
      clearTimeout(timer); autoPending = false; teaser.hidden = true;
      if (dialog.open) dialog.close();
      root.hidden = true;
    };
    window.addEventListener('bv:subscriber', hideForSubscriber);
    window.addEventListener('storage', hideForSubscriber);
    const previousVisit = readVisit();
    let internalReferrer = false;
    try {
      internalReferrer = new URL(document.referrer).hostname.replace(/^www\./, '') === location.hostname.replace(/^www\./, '');
    } catch {}
    const navigationType = performance.getEntriesByType?.('navigation')?.[0]?.type;
    const newEntry = !internalReferrer && navigationType !== 'back_forward';
    const newVisit = newEntry || !previousVisit.lastSeen || Date.now() - previousVisit.lastSeen >= visitWindow;
    const alreadyShown = !newVisit && previousVisit.shown === true;
    if (!preview) saveVisit({lastSeen:Date.now(), shown:alreadyShown});
    teaser.hidden = false;
    autoPending = preview || !alreadyShown;
    const showAfter = Date.now() + Math.max(10, Number(root.dataset.delay) || 10) * 1000;
    const showWhenReady = () => {
      if (!preview && knownSubscriber(root)) { hideForSubscriber(); return; }
      if (!autoPending || document.visibilityState !== 'visible') return;
      if (/INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '') || document.querySelector('dialog[open]')) {
        timer = setTimeout(showWhenReady, 1000);
        return;
      }
      open();
    };
    if (autoPending) timer = setTimeout(showWhenReady, Math.max(0, showAfter - Date.now()));
    document.addEventListener('visibilitychange', () => {
      if (!autoPending || document.visibilityState !== 'visible') return;
      clearTimeout(timer);
      timer = setTimeout(showWhenReady, Math.max(0, showAfter - Date.now()));
    });
  });
})();
